export const PIN_CODE_REGEX = /^\d{6}$/
export const PHONE_REGEX = /^\d{10}$/
export const NUMBER_REGEX = /^\d+$/